<template>
  <div class="archived props-group">
    <el-form-item label="归档">
      <el-switch v-model="archive.enable"></el-switch>
    </el-form-item>
    <el-form-item label="归档字段" v-if="archive.enable">
      <el-select v-model="archive.columnId" filterable>
        <el-option v-if="showCurrentOption" :key="archive.defaultArchivedId" label="[当前控件]" :value="archive.defaultArchivedId" />
        <el-option v-for="item in columnOptions" :key="item.id" :label="item | formatNew" :value="item.id" >
          <span v-html="formatName(item)"></span>
        </el-option>
      </el-select>
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: 'attr-archived',
  props: ['component'],
  inject: ['formService'],
  computed: {
    archive () {
      return this.component.archive
    },
    columnOptions () {
      return this.formService.getColumns(this.archive.tableId)
    },
    showCurrentOption () {
      return !this.columnOptions.some(m => m.id === this.archive.defaultArchivedId)
    },
    formatName () {
      return item => item.isNew ? `${item.name}<b class="new">（new）</b>` : item.name
    }
  },
  filters: {
    formatNew: (item) => item.isNew ? `${item.name}（new）` : item.name
  }
}
</script>

<style lang="scss">
.archived {
  border-top: 1px solid #c2c3c4;
  border-bottom: 1px solid #ebebeb;
  margin: 0 -20px;
  padding: 0 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/form/componentAttr/archived.vue